export const adminMenu = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: "pi pi-th-large"
  },
  {
    title: "Admin List",
    url: "/admin",
    icon: "pi pi-user"
  },

  {
    title: "Authority",
    url: "/authority",
    icon: "pi pi-home"
  },
  {
    title: "Settings",
    url: "#",
    icon: "pi pi-cog",
    submenu: [
      {
        title: "System Configuration",
        url: "/settings/housingAssociation",
        icon: "pi pi-building"
      },
      {
        title: "Document Templates",
        url: "/template",
        icon: "pi pi-file"
      },
      {
        title: "Notification Templates",
        url: "/notificationtemplate",
        icon: "pi pi-file"
      }
    ]
  }
];
